import { cn } from './cn';

/**
 * A scroller that keeps its gutter but shows no bar until the pointer is on
 * it, so a list that only just overflows does not wear a rail for it.
 *
 * Both spellings are set: Safari has no `scrollbar-width`, and a host page
 * that styles `::-webkit-scrollbar` globally would otherwise put its own bar
 * here. The token is spelled `--sk-fill-secondary` because inside an
 * arbitrary value there is no utility to resolve the name, prefix and all.
 *
 * The thumb answers to the scroller itself and to a `group/nav` around it,
 * which is how a nav reveals the bar from anywhere inside it.
 */
export const quietScrollbar = cn(
  'sk:[scrollbar-width:thin] sk:[scrollbar-color:transparent_transparent]',
  'sk:[transition:scrollbar-color_150ms]',
  'sk:[&::-webkit-scrollbar]:w-1.5',
  'sk:[&::-webkit-scrollbar-thumb]:rounded-full',
  'sk:[&::-webkit-scrollbar-thumb]:bg-transparent',
  'sk:hover:[scrollbar-color:var(--sk-fill-secondary)_transparent]',
  'sk:hover:[&::-webkit-scrollbar-thumb]:bg-fill-secondary',
  'sk:group-hover/nav:[scrollbar-color:var(--sk-fill-secondary)_transparent]',
  'sk:group-hover/nav:[&::-webkit-scrollbar-thumb]:bg-fill-secondary',
);
